import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CardContainerMultiColumn, {
    CardContainerMultiColumnStyles,
} from "@insite/content-library/Components/CardContainerMultiColumn";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Page from "@insite/mobius/Page";
import Popover, { OverflowWrapperProps, PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SearchIcon from "@tIntermatic/Icons/Search";
import ProductCompareFlyOut from "@tIntermatic/Overrides/Components/ProductCompareFlyOut";
import ProductListProductGridCard from "@tIntermatic/Overrides/Widgets/ProductList/ProductListProductGridCard";
import CustomApplicationState from "@tIntermatic/Store/CustomApplicationState";
import getMatchingIntermaticProduct from "@tIntermatic/Store/Data/ProductCrossReference/Handlers/GetMatchingIntermaticProducts";
import {
    getMatchingIntermaticPagination,
    getMatchingIntermaticProductList,
} from "@tIntermatic/Store/Data/ProductCrossReference/ProductCrossReferenceSelector";
import getCrossReferenceLookup from "@tIntermatic/Store/Data/ProductCrossReferenceLookup/Handlers/GetCrossReferenceLookup";
import { getProductCrossReferenceLookupList } from "@tIntermatic/Store/Data/ProductCrossReferenceLookup/ProductCrossReferenceLookupSelector";
import INTCrossRefProductListContext from "@tIntermatic/Widgets/CrossRefProductList/INTCrossRefProductListContext";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
    description = "description",
    placeholder = "placeholder",
}

interface OwnProps extends PageProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
        [fields.placeholder]: string;
    };
}

export interface IntProductCrossReferenceStyle {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: any;
    cardList?: CardListStyles | undefined;
    container?: GridContainerProps;
    listContainer?: GridItemProps;
    listItemContainer?: GridItemProps;
    nolistItemContainer?: GridItemProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    searchTextField?: TextFieldPresentationProps;
    imageWrapper?: InjectableCss;
    cardContainerMultiColumnStyles?: CardContainerMultiColumnStyles;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;

    parentWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    title?: InjectableCss;
    description?: InjectableCss;
    searchWrapper?: InjectableCss;
    defaultPageWrapper?: InjectableCss;
    loadingCss?: InjectableCss;
    resultsWrapper?: InjectableCss;
    matchingText?: InjectableCss;
    selectredResult?: InjectableCss;
    defaultNoResultFoundMsg?: InjectableCss;
    onLoadNoResults?: InjectableCss;
    suggestionList?: InjectableCss;
}

export const IntProductCrossReferenceStyle: IntProductCrossReferenceStyle = {
    container: {
        gap: 0,
        css: css`
            wdith: 100%;
            max-width: 1140px;
            margin: 0 auto;
            height: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border: 0;
                        margin-bottom: 0px;
                    `,
                    css`
                        border: 0;
                        margin-bottom: 0px;
                    `,
                    css`
                        border: 0;
                        margin-bottom: 0px;
                    `,
                    css`
                        border: 2px solid #e1e1e1;
                        margin-bottom: 56px;
                    `,
                    css`
                        border: 2px solid #e1e1e1;
                        margin-bottom: 56px;
                    `,
                ])}
        `,
    },
    listItemContainer: {
        width: 12,
        css: css`
            margin-top: -63px !important;
            background-color: #fff;
            padding: 0;
            margin-horizontal: 10px;
            margin-bottom: 29px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                            height: fit-content !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                            height: fit-content !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    nolistItemContainer: {
        width: 12,
        css: css`
            margin-top: -63px !important;
            background-color: #fff;
            padding: 0;
            margin-horizontal: 10px;
            margin-bottom: 29px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                            height: 500px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                            height: 500px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    searchTextField: {
        iconProps: { src: SearchIcon },
        cssOverrides: {
            formField: css`
                > div {
                    > button {
                        left: 2px;
                        padding: 24px !important;
                        transform: translateY(-40%);
                        top: 50% !important;
                        > span {
                            right: -1px !important;
                            top: 1px !important;
                            padding: 0px !important;
                            > svg {
                                stroke-width: 1;
                                color: #33333a;
                                height: 25px;
                                width: 25px;
                            }
                        }
                        &:hover {
                            svg {
                                g > g#Font_Home_Default {
                                    fill: #006bc0 !important;
                                }
                            }
                        }
                    }
                }
            `,
            inputSelect: css`
                border: 1px solid #cccccc;
                font-size: 24px;
                letter-spacing: 0;
                line-height: 17px;
                height: 55px;
                width: 100%;
                background: #fff;
                padding-left: 50px;
                ::placeholder {
                    color: rgba(0, 0, 0, 0.5);
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 17px;
                    position: relative;
                    bottom: 4px;
                }
                @media all and (max-width: 992px) and (min-width: 0px) {
                    border: 1px solid #cccccc;
                    &:focus {
                        border: 1px solid #cccccc !important;
                        padding-left: 50px;
                    }
                }

                ::-webkit-input-placeholder { / Chrome/Opera/Safari /
                    line-height: normal !important;
                    padding-top:10px;
                }
                 
                :-moz-placeholder { / Firefox 18- /
                text-align: center !important;  
                line-height: 55px !important;
                }
                 
                ::-moz-placeholder {  / Firefox 19+ /
                text-align: center !important; 
                line-height: 55px !important; 
                }

                &:focus {
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    color: #cccccc;
                    font-size: 24px;
                    letter-spacing: 0;
                    line-height: 17px;
                    color: #33333a;
                    padding-left: 50px;
                }
                max-width: 378px;
            `,
        },
    },
    cardContainerMultiColumnStyles: {
        cardDivider: {
            css: css`
                width: 100%;
                height: 100%;
                position: relative;
                min-height: 522px;
            `,
        },
        gridItem: {
            css: css`
                border-bottom: none;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        css`
                            padding: 20px;
                        `,
                    ])}
            `,
        },
    },
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            display: inline-flex;
            justify-content: flex-end;
        `,
    },
    popoverContentBody: {
        as: "div",
        _height: "100%",
        css: css`
            background: #fff;
            max-height: fit-content;
            position: absolute !important;
            top: 55px !important;
            max-width: 378px;
            left: 0 !important;
            width: 100%;
            button[class^="StyledButton"] {
                padding: 6px 18px;
                width: 100%;
                &:hover {
                    background-color: #e5e5e5;
                }
                > span {
                    color: #333333;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
        `,
    },
    autocompleteWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column-reverse;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 375px;
            padding: 0 20px 15px 20px;
        `,
    },

    parentWrapper: {
        css: css`
            max-width: 1140px;
            margin: 0 auto;
            width: 100%;
            display: flex;
            justify-content: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 720px !important;
                        `,
                        css`
                            max-width: 960px !important;
                        `,
                        css`
                            max-width: 1140px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    wrapper: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            padding: 30px 35px;
                            margin-bottom: 0px;
                            flex-direction: column;
                        `,
                        css`
                            width: 100%;
                            padding: 30px 35px;
                            margin-bottom: 0px;
                            flex-direction: column;
                        `,
                        css`
                            width: 100%;
                            padding: 22px;
                            margin-bottom: 63px;
                            flex-direction: column;
                        `,
                        css`
                            padding: 0px;
                            margin-bottom: 63px;
                            flex-direction: row;
                        `,
                        css`
                            padding: 0px;
                            margin-bottom: 63px;
                            flex-direction: row;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    title: {
        css: css`
            color: #ffffff;
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 1.08px;
            line-height: 25px;
        `,
    },

    description: {
        css: css`
            color: #ffffff;
            font-size: 46px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 53px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 36px;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 43px;
                        `,
                        css`
                            font-size: 36px;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 43px;
                        `,
                        css`
                            font-size: 36px;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 43px;
                        `,
                        css`
                            font-size: 44px;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 53px;
                        `,
                        css`
                            font-size: 44px;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 53px;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    defaultPageWrapper: {
        css: css`
            padding: 48px 43px;
            font-size: 21px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 25px;
            color: #33333a;
        `,
    },

    defaultNoResultFoundMsg: {
        css: css`
            padding: 48px 43px;
            font-size: 21px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 25px;
            color: #33333a;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding: 48px 140px;
                        `,
                        css`
                            padding: 48px 140px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    onLoadNoResults: {
        css: css`
            padding: 48px 43px;
            font-size: 21px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 25px;
            color: #33333a;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-bottom: 293px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    loadingCss: {
        css: css`
            height: 5px;
            width: 5px;
            background-color: #33333a;
            border-radius: 50%;
            display: inline-block;
            margin-right: 5px;
        `,
    },

    resultsWrapper: {
        css: css`
            padding: 48px 0;
            width: 100%;
            margin: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 30px;
                    `,
                    null,
                    null,
                    css`
                        max-width: 875px;
                    `,
                    css`
                        max-width: 875px;
                    `,
                ])}
        `,
    },
    matchingText: {
        css: css`
            color: #33333a;
            font-size: 21px;
            letter-spacing: 0;
            line-height: 25px;
            font-weight: 300;
            padding-bottom: 34px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 20px 48px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    selectredResult: {
        css: css`
            font-weight: bold;
            display: inline-block;
        `,
    },
    suggestionList: {
        css: css`
            background-color: #ffffff;
            width: 100%;
            > span {
                color: #333333 !important;
                padding: 8px 18px;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 20px;
                width: 100%;
            }
            &:hover,
            &:active {
                background-color: #e5e5e5;
            }
        `,
    },
};
const styles = IntProductCrossReferenceStyle;
const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state?.t_data?.matchingIntermaticProducts?.isLoading,
    crossRefProductLookupList: state?.t_data?.crossReferenceLookupList?.value?.names,
    matchingIntermaticProducts: getMatchingIntermaticProductList(state),
    matchingIntermaticPagination: getMatchingIntermaticPagination(state),
    myState: state,
});
const mapDispatchToProps = {
    getMatchingIntermaticProduct,
    getCrossReferenceLookup,
};
type Props = HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    OwnProps &
    PageProps;

const IntProductCrossReference = ({
    id,
    isLoading,
    matchingIntermaticProducts,
    matchingIntermaticPagination,
    crossRefProductLookupList,
    getMatchingIntermaticProduct,
    getCrossReferenceLookup,
    fields,
    myState,
}: Props) => {
    const [searchText, setSearchText] = useState("");
    const [autoCompleteList, setAutoCompleteList] = useState<string[]>([]);
    const list = React.createRef<HTMLUListElement>();
    const popoverelement = React.createRef<HTMLUListElement>();
    const [isInputActive, setIsInputActive] = useState(false);
    const openAutocomplete = () => {
        popoverelement.current && (popoverelement.current! as any).openPopover();
    };
    const closeAutocomplete = () => {
        // popoverelement.current && (popoverelement.current! as any).closePopover();
    };

    const getPopoverPosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top =
                rect.top +
                (rect.height > 100
                    ? sizeVariantValues[styles?.input?.sizeVariant || ("default" as FormFieldSizeVariant)].height
                    : rect.height);
            positionStyle.right = document.documentElement.clientWidth - rect.right;
        }

        return positionStyle;
    };
    const doSearch = () => {
        if (searchText.trim() !== "") {
            getMatchingIntermaticProduct({
                Search: searchText,
                onSuccess: result => {
                    if (result) {
                        setIsInputActive(false);
                    }
                },
            });
        }
        setAutoCompleteList([]);
        closeAutocomplete();
    };
    const doLinkSearch = (searchString: string) => {
        if (searchString.trim() !== "") {
            getMatchingIntermaticProduct({
                Search: searchString,
                onSuccess: result => {
                    if (result) {
                        setIsInputActive(false);
                    }
                },
            });
        }
        setAutoCompleteList([]);
        closeAutocomplete();
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && event.currentTarget.value.length > 0) {
            event.preventDefault();
            doSearch();
        } else if (event.currentTarget.value.length > 0) {
            setIsInputActive(false);
        }
    };

    const loadAutocomplete = debounce((searchString: string) => {
        if (searchString.length > 0) {
            getCrossReferenceLookup({
                search: searchString,
                onSuccess: result => {
                    if (result) {
                        setAutoCompleteList(result.names);
                        openAutocomplete();
                    } else {
                        setAutoCompleteList([]);
                        closeAutocomplete();
                    }
                },
            });
        } else {
            setAutoCompleteList([]);
            closeAutocomplete();
        }
    }, 100);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.value.length > 0) {
            setIsInputActive(true);
        } else {
            setIsInputActive(false);
        }
        setSearchText(event.currentTarget.value);
        loadAutocomplete(event.currentTarget.value);
    };

    const containerStyles = {
        css: css`
            background-color: rgba(59, 59, 65, 1);
            min-height: 497px;
            justify-content: center;
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            min-height: 388px;
                        `,
                        css`
                            min-height: 388px;
                        `,
                        css`
                            min-height: 388px;
                        `,
                        css`
                            min-height: 497px;
                        `,
                        css`
                            min-height: 497px;
                        `,
                    ],
                    "min",
                )}
        `,
    };
    return (
        <Page
            css={css`
                max-width: 100% !important;
                padding: 0 !important;
            `}
        >
            <StyledWrapper {...containerStyles}>
                <StyledWrapper {...styles.parentWrapper}>
                    <StyledWrapper {...styles.wrapper}>
                        <StyledWrapper
                            id="left_col"
                            css={css`
                                flex: 1;
                            `}
                        >
                            <Typography as="h3" {...styles.title}>
                                {fields?.title}
                            </Typography>
                            {fields.description && (
                                <Typography as="p" {...styles.description}>
                                    {fields.description}
                                </Typography>
                            )}
                        </StyledWrapper>
                        <StyledWrapper
                            id="right_col"
                            css={css`
                                flex: 1;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            padding: 42px 0;
                                        `,
                                        css`
                                            padding: 42px 0;
                                        `,
                                        css`
                                            padding: 42px 0;
                                        `,
                                        null,
                                        null,
                                    ])}
                            `}
                        >
                            <StyledWrapper
                                id="searchWrapper"
                                css={css`
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(theme, [
                                            null,
                                            null,
                                            null,
                                            css`
                                                padding-left: 96px;
                                                padding-top: 30px;
                                            `,
                                            css`
                                                padding: 30px 96px 0 96px;
                                            `,
                                        ])}
                                `}
                            >
                                <Popover
                                    {...styles.popover}
                                    controlsId="crossRef-popover"
                                    ref={popoverelement}
                                    insideRefs={[list]}
                                    popoverTrigger={
                                        <TextField
                                            {...styles.searchTextField}
                                            iconClickableProps={{ onClick: doSearch }}
                                            value={searchText}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyDown}
                                            placeholder={fields?.placeholder}
                                            type="text"
                                            autoComplete="off"
                                            data-test-selector="matchingIntermaticProductSearch"
                                            id="crossReferenceSearch"
                                            onBlur={() => {
                                                setIsInputActive(false);
                                                doSearch();
                                            }}
                                        />
                                    }
                                    positionFunction={getPopoverPosition}
                                    wrapperProps={styles.popoverWrapper}
                                    contentBodyProps={
                                        {
                                            ref: list,
                                            ...styles.popoverContentBody,
                                        } as any
                                    }
                                >
                                    {autoCompleteList &&
                                        autoCompleteList.map(crossRef => (
                                            <StyledWrapper key={crossRef}>
                                                <Link
                                                    onMouseDown={() => {
                                                        setSearchText(crossRef);
                                                        doLinkSearch(crossRef);
                                                    }}
                                                    {...styles.suggestionList}
                                                >
                                                    {crossRef}
                                                </Link>
                                            </StyledWrapper>
                                        ))}
                                </Popover>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <GridContainer {...styles.container}>
                <GridItem
                    {...(matchingIntermaticProducts && matchingIntermaticProducts?.length > 0
                        ? { ...styles.listItemContainer }
                        : { ...styles.nolistItemContainer })}
                >
                    {((!isInputActive && !isLoading && matchingIntermaticProducts === undefined) ||
                        (matchingIntermaticProducts && searchText === "")) && (
                        <StyledWrapper {...styles.onLoadNoResults}>{translate("No results")}</StyledWrapper>
                    )}

                    {!isInputActive &&
                        matchingIntermaticProducts &&
                        matchingIntermaticProducts.length === 0 &&
                        searchText !== "" && (
                            <StyledWrapper {...styles.onLoadNoResults}>
                                {siteMessage("No_Result_Message")}&nbsp;
                                <StyledWrapper {...styles.selectredResult}>{searchText}</StyledWrapper>
                            </StyledWrapper>
                        )}

                    {isInputActive && (
                        <StyledWrapper {...styles.onLoadNoResults}>
                            <StyledWrapper {...styles.loadingCss}></StyledWrapper>
                            <StyledWrapper {...styles.loadingCss}></StyledWrapper>
                            <StyledWrapper {...styles.loadingCss}></StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!isInputActive &&
                        !isLoading &&
                        searchText !== "" &&
                        matchingIntermaticProducts &&
                        matchingIntermaticProducts.length > 0 && (
                            <StyledWrapper id="results" {...styles.resultsWrapper}>
                                <StyledWrapper {...styles.matchingText}>
                                    {siteMessage("Matching_Results")}&nbsp;
                                    <StyledWrapper {...styles.selectredResult}>{searchText}</StyledWrapper>
                                </StyledWrapper>
                                <CardList
                                    extendedStyles={styles.cardList}
                                    data-test-selector="productListCardContainerGrid"
                                >
                                    {matchingIntermaticProducts &&
                                        matchingIntermaticProducts.map(product => (
                                            <INTCrossRefProductListContext product={product} key={product.id}>
                                                <CardContainerMultiColumn
                                                    extendedStyles={styles.cardContainerMultiColumnStyles}
                                                >
                                                    <ProductListProductGridCard
                                                        showImage={true}
                                                        showAttributes={false}
                                                        showAvailability={false}
                                                        showBrand={true}
                                                        showPartNumbers={true}
                                                        showTitle={true}
                                                        showCompare={true}
                                                        showAddToList={false}
                                                        showPrice={false}
                                                    />
                                                </CardContainerMultiColumn>
                                            </INTCrossRefProductListContext>
                                        ))}
                                </CardList>
                            </StyledWrapper>
                        )}
                </GridItem>
            </GridContainer>
            <ProductCompareFlyOut />
        </Page>
    );
};

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(IntProductCrossReference)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        supportsCategorySelection: true,
        pageType: "Content",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 1,
            },
            {
                name: fields.description,
                displayName: "description",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 2,
            },
            {
                name: fields.placeholder,
                displayName: "Placeholder text",
                editorTemplate: "TextField",
                defaultValue: "Enter manufacturer’s product number",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 3,
            },
        ],
    },
};

export default pageModule;
